import React from "react";
import MDBox from "components/MDBox";
import { Badge, TableCell, TableRow } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { gpsStatusBadgeColor } from "utils/constant";


const AssetTracker = ({ data, styles, onShowOnMap }) => {

    return (
        <>
            <TableRow>
                <TableCell colSpan={2} style={{ padding: 0 }}>
                    <hr style={{ border: "1px solid #e0e0e0", margin: "12px 0" }} />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={styles.cell}>
                    <MDTypography fontSize={1}>
                        <strong>
                            Device:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell style={styles.cell}>
                    <MDTypography fontSize={1}>
                        {data?.device_id} / {data?.device_data?.name}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Device Status:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <Badge
                            color={gpsStatusBadgeColor(data?.device_value?.moment_status)}
                            variant={'standard'}
                            badgeContent={data?.device_value?.moment_status}
                            style={{ marginLeft: "15px" }}
                        ></Badge>
                        {/* {data?.moment_status} */}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Speed:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {data?.device_value?.convert_position_speed} mph
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Heading:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {data?.device_value?.position_direction}°
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Latitude:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {data?.device_value?.position_latitude}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Longitude:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {data?.device_value?.position_longitude}
                    </MDTypography>
                </TableCell>
            </TableRow>
            {onShowOnMap && (
                <TableRow>
                    <TableCell colSpan={2} style={styles.cell}>
                        <MDButton
                            size="small"
                            variant="text"
                            color="info"
                            sx={{ px: 0 }}
                            startIcon={<i className="fa-solid fa-location-crosshairs" />}
                            onClick={() => onShowOnMap(data?.device_id)}
                        >
                            Show on map
                        </MDButton>
                    </TableCell>
                </TableRow>
            )}
        </>
    )

}

const PumpMonitor = ({ data, styles }) => {
    const channels = data?.device_value?.channels || data?.device_value || {}
    const PSI = channels?.[10]?.current_value ?? 'N/A'
    const Percent = channels?.[9]?.current_value ?? 'N/A'
    const Volume = channels?.[9]?.volume_level ?? 'N/A'
    return (
        <>
            <TableRow>
                <TableCell colSpan={2} style={{ padding: 0 }}>
                    <hr style={{ border: "1px solid #e0e0e0", margin: "12px 0" }} />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={styles.cell}>
                    <MDTypography fontSize={1}>
                        <strong>
                            Device:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell style={styles.cell}>
                    <MDTypography fontSize={1}>
                        {data?.device_id} / {data?.device_data?.name}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Pressure (PSI):
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {PSI}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Percent Level:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                       {Percent}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Volume:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {Volume} Gallons
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Latitude:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {data?.entity_address_item?.latitude}
                    </MDTypography>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong>
                            Longitude:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        {data?.entity_address_item?.longitude}
                    </MDTypography>
                </TableCell>
            </TableRow>
        </>
    )

}

export const LinkedDeviceView = ({ data, styles, onShowOnMap }) => {
    if (data?.device_data?.device_type_id === 8) {
        return <AssetTracker data={data} styles={styles} onShowOnMap={onShowOnMap} />
    }
    if (data?.device_data?.device_type_id == 9 || data?.device_type_id === 9) {
        return <PumpMonitor data={data} styles={styles} />
    }


    return (
        <MDBox mt={5} mb={5}>
            <div
            >
            </div>
        </MDBox>
    );
};

export default LinkedDeviceView;
